var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.9982 10.452V39.052C43.9993 39.8135 43.8265 40.5652 43.4929 41.2498C43.1592 41.9343 42.6737 42.5336 42.0732 43.002C41.1892 43.6762 40.1099 44.0448 38.9982 44.052C38.5936 44.0507 38.1906 44.0003 37.7982 43.902L21.9982 37.952L19.1982 37.252H14.4982C11.226 37.2515 8.08451 35.968 5.74818 33.677C3.97565 31.9388 2.76082 29.7123 2.25853 27.2811C1.75624 24.8499 1.98926 22.3242 2.92787 20.0259C3.86649 17.7276 5.46819 15.7609 7.52881 14.3764C9.58943 12.9919 12.0156 12.2523 14.4982 12.252H19.1982L37.7982 5.60198C38.5324 5.4187 39.2987 5.40448 40.0392 5.56038C40.7797 5.71628 41.4752 6.03823 42.0732 6.50198C42.6737 6.97032 43.1592 7.56962 43.4929 8.25418C43.8265 8.93874 43.9993 9.69046 43.9982 10.452Z",
    fill: "#3364FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.998 40.5271V49.7521C21.998 51.0782 21.4713 52.35 20.5336 53.2877C19.5959 54.2254 18.3241 54.7521 16.998 54.7521H14.048C12.8748 54.7746 11.731 54.3837 10.8169 53.6479C9.90282 52.912 9.27666 51.8781 9.04805 50.7271L6.49805 37.4521C7.8345 38.3075 9.30487 38.9329 10.848 39.3021C12.0412 39.6038 13.2674 39.755 14.498 39.7521H18.898L21.998 40.5271Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48 13.7031L56 9.70312",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56 39.7031L48 35.7031",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M48 24.7031H56",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon3.38f96cb33194a3632865afa9a009d7e2.svg";
export { ForwardRef as ReactComponent };